import { PayloadAction } from '@reduxjs/toolkit';
import { editOrganizacion as callEditOrganizacion } from '../../api/organizaciones/editOrganizacion';
import { GenericState } from '../../types/apiModule';
import { Organizacion } from '../../types/organizaciones/organizacion';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { listOrganizacionesRefresh } from './listOrganizacionModule';
import { t } from '../../i18n';

export interface editOrganizacionModule extends GenericState<unknown> {
  active: boolean;
  organizacion: Organizacion;
}
const initialState: editOrganizacionModule = {
  errors: null,
  data: [],
  loading: false,
  active: false,
  organizacion: {} as Organizacion,
};

const editOrganizacionModule = createApiModule({
  name: 'editOrganizacion',
  initialState,
  apiMethod: callEditOrganizacion,
  onSuccess: (organizacion) => [
    showSnackBar({
      severity: 'success',
      message: t('StoreNombreCambiadoCorrectamente', {
        nombre: organizacion.nombre,
      }),
    }),
    listOrganizacionesRefresh(),
  ],
  onError: () => ({
    message: t(
      'StoreOrganizacionesUpdateOrganizacionModuleErrorModificandoLaOrganizacion',
    ),
  }),
  onValidationError: () => ({
    message: t('MESSAGE_ERROR_CAMBIAR_NOMBRE'),
  }),
  reducers: {
    show(state, action: PayloadAction<Organizacion>) {
      state.active = true;
      state.organizacion = action.payload;
    },
    hide(state) {
      state.active = false;
    },
  },
});

export const {
  start: editOrganizacion,
  success: editOrganizacionOk,
  error: editOrganizacionKo,
  hide,
  show,
} = editOrganizacionModule.slice.actions;

export const { sagas } = editOrganizacionModule;

export default editOrganizacionModule;
